import _ from 'lodash';
import biLogger from 'web-bi-logger';
import * as CARD_SIZES from '../../app/constants/card-sizes';
import * as LAYOUT_TYPES from '../../app/constants/layout-types';
import * as CATEGORY_TEXT_ALIGNMENT from '../constants/text-alignment';
import detectRoute, { POST_PAGE, FEED_PAGE, routeMap } from '../services/detect-route';
import Wix from '../services/wix-sdk-polyfill';
import { getPreviousLocation, getCurrentLocation } from '../selectors/location-history-selectors';

export function getReferrer(state) {
  return detectRoute(getPreviousLocation(state));
}

export function getCurrentOrigin(state) {
  return detectRoute(getCurrentLocation(state));
}

export function createBi({ endpoint, src }) {
  return biLogger
    .factory({ endpoint })
    .setDefaults({
      src,
      app_id: '14724f35-6794-cd1a-0244-25fd138f9242',
      app_site_id: Wix.Utils.getInstanceId(),
      instance_id: Wix.Utils.getInstanceId(),
    })
    .logger();
}

export function getSelectedItem(action) {
  const payload = action.payload;

  const selected_item_position = parseInt(payload.selected_item_position, 10) + 1;
  const id = parseInt(payload.selected_item_name, 10);

  const selected_item_name = _.findKey(LAYOUT_TYPES, type => type === id).toLowerCase();
  return {
    selected_item_position,
    selected_item_name,
  };
}

export function getPostSlugFromPathname(pathname) {
  return pathname.match(routeMap[POST_PAGE])[1];
}

export function getCategorySlugFromPathname(pathname) {
  return pathname.match(routeMap[FEED_PAGE])[1];
}

export function getLayoutName(id) {
  id = parseInt(id, 10);
  return _.findKey(LAYOUT_TYPES, type => type === id).toLowerCase();
}

export function getCardSizeName(id) {
  id = parseInt(id, 10);
  return _.findKey(CARD_SIZES, type => type === id).toLowerCase();
}

export function getTextAlignmentName(id) {
  id = parseInt(id, 10);
  return _.findKey(CATEGORY_TEXT_ALIGNMENT, type => type === id).toLowerCase();
}

export function getImageCount(entity) {
  const content = entity.content;
  return _.filter(content.entityMap, entity => entity.type === 'IMAGE').length;
}

export function getQuoteCount(entity) {
  const content = entity.content;
  return _.filter(content.blocks, entity => entity.type === 'blockquote').length;
}

export function getVideoCount(entity) {
  const content = entity.content;
  return _.filter(content.entityMap, entity => entity.type === 'VIDEO' || entity.type === 'VIDEO-EMBED').length;
}

export function hasBiToken(event) {
  return !!event.biToken;
}

export function isNotDummyVisitorId(event) {
  return event.visitor_id !== '00000000-0000-0000-0000-000000000000';
}

export function isNotEditor() {
  return Wix.Utils.getViewMode() !== 'editor';
}

export function hasMemberId(event) {
  return !!event.member_id;
}



// WEBPACK FOOTER //
// ./app/bi-events/bi-helpers.js